export default (args) => {
  const {
    background,
    btn_background,
    btn_font_size,
    btn_font_weight,
    btn_text_color,
    color,
    font_family,
    font_size,
  } = args

  return {
    previewStyle: {
      fontFamily: font_family,
      fontSize: font_size,
      color,
      background,
    },
    btnStyle: {
      background: btn_background,
      borderColor: btn_background,
      color: btn_text_color,
      fontSize: btn_font_size,
      fontFamily: font_family,
      fontWeight: btn_font_weight,
      preferencesBtnColor: color,
    },
    textStyle: {
      fontFamily: font_family,
      fontSize: font_size,
      color,
    },
  }
}
